import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Loader from '../components/loader/Loader'
import { UserRole } from '../types/generalType'
import { NotFound } from './lazy/lazy'

import routeData from './route/routeData'

const Routing = () => {
  const user = JSON.parse(localStorage.getItem('user') ?? '{}')
  return (
    <Suspense fallback={<Loader loading />}>
      <Routes>
        {routeData.map(
          (route) =>
            user?.role?.find((role: UserRole) => route.roleAccess?.includes(role)) && (
              <Route key={route.key} path={route.path} element={route.element} />
            ),
        )}
        <Route key={'not-found'} path='*' element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}

export default Routing
